export default "__VITE_ASSET__C7wtwm5c__"